import { EmptyGrid, Grid, GridLayout } from "@/app/grid"
import { NftPreviewSkeleton } from "@/app/nft/preview"
import { useNftSearchResult } from "@/app/nft/search/result/hooks.reatom"
import { DEFAULT_PAGE_SIZE } from "@anaconda/core/nft/search/constants"
import { reatomComponent } from "@reatom/react"
import { useCallback } from "react"
import { EmptyMessage } from "../empty-message"
import { useGridItems } from "./hooks"
import { GridItem, GridItemType } from "./item"

export const GridView = reatomComponent(() => {
  const nftSearchResult = useNftSearchResult()
  const items = useGridItems(
    nftSearchResult.nfts,
    nftSearchResult.nextPageLoading,
  )

  const computeItemKey = useCallback((index: number, item: GridItem) => {
    if (item.type === GridItemType.PLACEHOLDER) return `placeholder-${index}`

    return item.nft.id
  }, [])

  if (!nftSearchResult.nfts.length) {
    return <EmptyGrid EmptyMessage={EmptyMessage} />
  }

  return (
    <div className="pt-2" data-testid="collection-grid-view">
      <Grid
        computeItemKey={computeItemKey}
        items={items}
        loadNextPage={nftSearchResult.loadNextPage}
        ItemContent={GridItem}
        initialItemCount={DEFAULT_PAGE_SIZE}
      />
    </div>
  )
}, "GridView")

export function GridSkeleton() {
  const placeholders = Array.from({ length: DEFAULT_PAGE_SIZE })

  return (
    <GridLayout>
      {placeholders.map((_, index) => (
        <NftPreviewSkeleton key={index} />
      ))}
    </GridLayout>
  )
}
